'use strict';
import HTTPClientBase from './factory/HTTPClientBase.js';

/**
 * @description Factory method for creating new Axios clients
 * @extends HTTPClientBase
 */
class HTTPClient extends HTTPClientBase {
  /**
   * @param {*} config All params passed to the HTTPClientBase
   */
  constructor(config) {
    super({ opts: config });
  }

  /**
   * @summary Set a base URL for the client instance
   * @param {string} url The base URL path of the endpoint
   */
  setBaseUrl (url) {
    this._client.defaults.baseURL = url;
    return this;
  }

  /**
   * @summary Send a GET request
   * @param {string} url The URL path for the request
   * @param {object} headers Optional headers to be sent with the request
   * @param {function} cb An optional callback that accepts the response object
   */
  get ({ url, headers }, cb) {
    return this._client({
      method: 'get',
      headers,
      url
    }).then(cb)
      .catch(cb);
  }

  /**
   * @summary Send a POST request
   * @param {string} url The URL path for the request
   * @param {object} data The data object to be sent with the request
   * @param {object} headers Optional headers to be sent with the request
   * @param {function} cb An optional callback that accepts the response object
   */
  post ({ url, headers, data }, cb) {
    return this._client({
      method: 'post',
      url,
      headers,
      data
    }).then(cb)
      .catch(cb);
  }

  /**
   * @summary Send a GET request expecting a blob object response
   * @param {string} url The URL path for the request
   * @param {object} headers Optional headers to be sent with the request
   * @param {function} cb An optional callback that accepts the response object
   */
  getBlob ({ url, headers }, cb) {
    return this._client({
      method: 'get',
      url,
      headers,
      responseType: 'blob'
    }).then(cb)
      .catch(cb);
  }

  /**
   * @summary Send a POST request containing a blob object payload
   * @param {string} url The URL path for the request
   * @param {object} data The data object to be sent with the request
   * @param {object} headers Optional headers to be sent with the request
   * @param {function} cb An optional callback that accepts the response object
   */
  postBlob ({ url, headers, data }, cb) {
    return this._client({
      method: 'post',
      url,
      headers,
      responseType: 'blob',
      data
    }).then(cb)
      .catch(cb);
  }
}

export default HTTPClient;